import * as React from 'react';

export const GridInterface = props => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.53992 13.9585C3.87343 13.9585 3.33325 14.4987 3.33325 15.1652V15.6685C3.33325 16.335 3.87343 16.8752 4.53992 16.8752H6.70992C7.37641 16.8752 7.91659 16.335 7.91659 15.6685V15.1652C7.91659 14.4987 7.37641 13.9585 6.70992 13.9585H4.53992ZM2.08325 15.1652C2.08325 13.8083 3.18308 12.7085 4.53992 12.7085H6.70992C8.06676 12.7085 9.16659 13.8083 9.16659 15.1652V15.6685C9.16659 17.0253 8.06676 18.1252 6.70992 18.1252H4.53992C3.18308 18.1252 2.08325 17.0253 2.08325 15.6685V15.1652Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.53992 3.125C3.87343 3.125 3.33325 3.66517 3.33325 4.33167V8.16833C3.33325 8.83483 3.87343 9.375 4.53992 9.375H6.70992C7.37641 9.375 7.91659 8.83483 7.91659 8.16833V4.33167C7.91659 3.66517 7.37641 3.125 6.70992 3.125H4.53992ZM2.08325 4.33167C2.08325 2.97483 3.18308 1.875 4.53992 1.875H6.70992C8.06676 1.875 9.16659 2.97483 9.16659 4.33167V8.16833C9.16659 9.52517 8.06676 10.625 6.70992 10.625H4.53992C3.18308 10.625 2.08325 9.52517 2.08325 8.16833V4.33167Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7067 3.125C13.0402 3.125 12.5 3.66517 12.5 4.33167V15.6683C12.5 16.3348 13.0402 16.875 13.7067 16.875H15.8767C16.5432 16.875 17.0833 16.3348 17.0833 15.6683V4.33167C17.0833 3.66517 16.5432 3.125 15.8767 3.125H13.7067ZM11.25 4.33167C11.25 2.97483 12.3498 1.875 13.7067 1.875H15.8767C17.2335 1.875 18.3333 2.97483 18.3333 4.33167V15.6683C18.3333 17.0252 17.2335 18.125 15.8767 18.125H13.7067C12.3498 18.125 11.25 17.0252 11.25 15.6683V4.33167Z"
      fill="#64748B"
    />
  </svg>
);
